module.exports = __webpack_public_path__ + "static/media/logo.4a38ead9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/maitres/logo.png
// module id = 64
// module chunks = 0